import React from "react";
import { NavLink } from "react-router-dom";
import { useVisibility } from "../context/VisibilityContext";
import MenuModal from "../modals/MenuModal";

const FooterMobile = () => {
  const { areButtonsVisible } = useVisibility();
  return (
    <div className="grid-conatiner-mobile">
      <footer
        className={`footer fixed-bottom bg-white `}
        style={{
          boxShadow: areButtonsVisible
            ? "none"
            : "0px -4px 4px 0px rgba(0, 0, 0, 0.12)",
        }}>
        <div className="footer-links-container d-flex justify-content-between align-items-center">
          <span className=" mb-2 mb-md-0">
            <NavLink
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              to="/">
              <div className="d-flex flex-column align-items-center justify-content-center gap-1 mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none">
                  <path
                    d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                    stroke="black"
                    strokeWidth="2"
                  />
                  <path
                    d="M9.02584 9.02585L14.5907 7.09737L12.6622 12.6622L7.09737 14.5907L9.02584 9.02585Z"
                    stroke="black"
                    strokeWidth="2"
                  />
                </svg>
                <p className="footer-link-names">Strategy</p>
              </div>
            </NavLink>
          </span>{" "}
          <span className=" mb-2 mb-md-0">
            <NavLink
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              to="/optionchain">
              <div className="d-flex flex-column align-items-center justify-content-center gap-1 mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none">
                  <path
                    d="M10.5282 5.65801L13.8061 2.32422C15.5318 0.569048 18.3574 0.557109 20.098 2.29763C21.8281 4.02781 21.8281 6.83297 20.098 8.56315L16.1406 12.5205C14.6379 14.0232 12.216 14.0687 10.658 12.6236L9.54007 11.5867M11.8674 16.342L8.58951 19.6758C6.86376 21.431 4.03815 21.4429 2.29763 19.7024C0.567457 17.9722 0.567456 15.167 2.29763 13.4369L6.255 9.47947C7.75767 7.9768 10.1796 7.93129 11.7376 9.37643L12.8555 10.4133"
                    stroke="#14142B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="footer-link-names">Options</p>
              </div>
            </NavLink>
          </span>{" "}
          <span className=" mb-2 mb-md-0">
            <NavLink
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              to="/positions">
              <div className="d-flex flex-column align-items-center justify-content-center gap-1 mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none">
                  <path
                    d="M11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12V10ZM13 12C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10V12ZM4 6H20V4H4V6ZM22 8V18H24V8H22ZM20 20H4V22H20V20ZM2 18V8H0V18H2ZM4 20C2.89543 20 2 19.1046 2 18H0C0 20.2091 1.79086 22 4 22V20ZM22 18C22 19.1046 21.1046 20 20 20V22C22.2091 22 24 20.2091 24 18H22ZM20 6C21.1046 6 22 6.89543 22 8H24C24 5.79086 22.2091 4 20 4V6ZM4 4C1.79086 4 0 5.79086 0 8H2C2 6.89543 2.89543 6 4 6V4ZM10 2H14V0H10V2ZM15 3V5H17V3H15ZM9 5V3H7V5H9ZM14 2C14.5523 2 15 2.44772 15 3H17C17 1.34315 15.6569 0 14 0V2ZM10 0C8.34315 0 7 1.34315 7 3H9C9 2.44772 9.44772 2 10 2V0ZM1 13C0.476984 13.8523 0.477235 13.8525 0.477504 13.8526C0.477619 13.8527 0.477908 13.8529 0.478137 13.853C0.478597 13.8533 0.479132 13.8536 0.479742 13.854C0.480961 13.8548 0.482481 13.8557 0.484298 13.8568C0.487933 13.859 0.492759 13.8619 0.498765 13.8655C0.510775 13.8728 0.5275 13.8827 0.548829 13.8953C0.591482 13.9204 0.652569 13.9559 0.731189 14.0002C0.888394 14.0887 1.11593 14.2128 1.40658 14.3604C1.98746 14.6554 2.82293 15.0458 3.85506 15.4355C5.91328 16.2128 8.78673 17 12 17V15C9.10216 15 6.47561 14.2872 4.56161 13.5645C3.60763 13.2042 2.83893 12.8446 2.31217 12.5771C2.049 12.4435 1.84685 12.3331 1.71282 12.2576C1.64583 12.2199 1.59591 12.1909 1.56396 12.1721C1.54799 12.1627 1.53652 12.1558 1.52966 12.1517C1.52623 12.1496 1.52395 12.1482 1.52284 12.1476C1.52228 12.1472 1.52202 12.1471 1.52205 12.1471C1.52206 12.1471 1.52215 12.1471 1.52231 12.1472C1.52239 12.1473 1.52257 12.1474 1.52261 12.1474C1.5228 12.1475 1.52302 12.1477 1 13ZM12 17C15.2133 17 18.0867 16.2128 20.1449 15.4355C21.1771 15.0458 22.0125 14.6554 22.5934 14.3604C22.8841 14.2128 23.1116 14.0887 23.2688 14.0002C23.3474 13.9559 23.4085 13.9204 23.4512 13.8953C23.4725 13.8827 23.4892 13.8728 23.5012 13.8655C23.5072 13.8619 23.5121 13.859 23.5157 13.8568C23.5175 13.8557 23.519 13.8548 23.5203 13.854C23.5209 13.8536 23.5214 13.8533 23.5219 13.853C23.5221 13.8529 23.5224 13.8527 23.5225 13.8526C23.5228 13.8525 23.523 13.8523 23 13C22.477 12.1477 22.4772 12.1475 22.4774 12.1474C22.4774 12.1474 22.4776 12.1473 22.4777 12.1472C22.4779 12.1471 22.4779 12.1471 22.478 12.1471C22.478 12.1471 22.4777 12.1472 22.4772 12.1476C22.4761 12.1482 22.4738 12.1496 22.4703 12.1517C22.4635 12.1558 22.452 12.1627 22.436 12.1721C22.4041 12.1909 22.3542 12.2199 22.2872 12.2576C22.1532 12.3331 21.951 12.4435 21.6878 12.5771C21.1611 12.8446 20.3924 13.2042 19.4384 13.5645C17.5244 14.2872 14.8978 15 12 15V17ZM11 12H13V10H11V12Z"
                    fill="#14142B"
                  />
                </svg>
                <p className="footer-link-names">Positions</p>
              </div>
            </NavLink>
          </span>{" "}
          <span className=" mb-2 mb-md-0">
            <NavLink
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              to="/orders">
              <div className="d-flex flex-column align-items-center justify-content-center gap-1 mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none">
                  <path
                    d="M19 1C21 1 21 3 21 3V6H17M19 1C17 1 17 3 17 3V6M19 1H6C4 1 4 3 4 3V16M17 6V19C17 19 17 21 15 21M15 21C13 21 13 19 13 19V16H1V19C1 19 1 21 3 21H15ZM8 7H13M8 11H13"
                    stroke="#14142B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="footer-link-names">Orders</p>
              </div>
            </NavLink>
          </span>
          <span className=" mb-2 mb-md-0">
            <span
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#menuModal"
              className="inactive">
              <div className="inactive d-flex flex-column align-items-center justify-content-center gap-2 mt-2">
                <svg
                  width="23"
                  height="18"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 1H22M1 7.5H22M1 14H22"
                    stroke="#14142B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p className="footer-link-names inactive">Menu</p>
              </div>
            </span>
          </span>
        </div>
        <MenuModal />
      </footer>
    </div>
  );
};

export default FooterMobile;
